import qs from 'qs'
import { NextRouter } from 'next/router'
import * as Sentry from '@sentry/nextjs'

import { getLocaleMeasurementSystemByPipelineId } from './localeHelper'
import {
  PIPELINE_ID,
  Order,
  Utms,
  API_ORDER_KEYS,
  ContextOrder,
} from 'types/order'

export const getPipelineId = (router: NextRouter): number => {
  const pipelineId: number = PIPELINE_ID[router.locale][router.query.pipe]

  if (!pipelineId) {
    Sentry.captureException(
      new Error(
        `Couldnt finde pipeline ID in config by locale: ${router.locale} and pipe: ${router.query.pipe}`
      )
    )
  }

  return pipelineId
}

export const getColoring = (router: NextRouter): Utms => {
  return {
    utm_source: router.query.utm_source as string,
    utm_medium: router.query.utm_medium as string,
    utm_campaign: router.query.utm_campaign as string,
    utm_term: router.query.utm_term as string,
    utm_content: router.query.utm_content as string,
  }
}

export const getCustomData = (router: NextRouter): any => {
  // Pipe is - series, for example, o not neccessery to send
  // Utms are - coloring, and it is its own param
  const whiteList: string[] = [
    'pipe',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ]
  const currentParams = router.query
  // Remove default values from queryParams and add rest of the key value pairs to new filteredParams object
  const filteredParams = Object.keys(currentParams)
    .filter((param) => !whiteList.includes(param))
    .reduce((acc, currentValue) => {
      acc[currentValue] = currentParams[currentValue]
      return acc
    }, {})

  return filteredParams
}

export const getInitialContextOrderValues = (
  pipelineId: number
): ContextOrder => {
  return {
    orderId: 0,
    pipeLineId: 0,
    name: '',
    weight: 0,
    height: 0,
    age: '',
    gender: '',
    goalWeight: 0,
    measurementSystem: getLocaleMeasurementSystemByPipelineId(pipelineId),
  }
}

export const mapOrderValues = (order: Order): ContextOrder => {
  const { id, pipeline_id, meta } = order

  let orderValues = getInitialContextOrderValues(pipeline_id)
  orderValues = {
    ...orderValues,
    orderId: id,
    pipeLineId: pipeline_id,
  }

  API_ORDER_KEYS.forEach((element) => {
    if (!meta[element]) {
      return
    }

    switch (element) {
      case 'age':
        orderValues = { ...orderValues, age: meta[element].toString() }
        return
      case 'name':
        orderValues = { ...orderValues, name: meta[element] }
        return
      case 'height':
        orderValues = { ...orderValues, height: meta[element] }
        return
      case 'weight':
        orderValues = { ...orderValues, weight: meta[element] }
        return
      case 'gender':
        orderValues = { ...orderValues, gender: meta[element] }
        return
      case 'goal_weight':
        orderValues = {
          ...orderValues,
          goalWeight: meta[element],
        }
        return
      case 'unit_system':
        orderValues = {
          ...orderValues,
          measurementSystem: meta[element],
        }
        return
      default:
        return
    }
  })

  return orderValues
}

export const isGlobalContextOrderValid = (order: ContextOrder): boolean =>
  order.orderId !== 0

export const getLoginLink = (email: string, accessToken: string): string => {
  const queryParams = {
    email: email,
  }

  if (!accessToken) {
    return 'https://app.certifiedketodiet.com/'
  }

  return `https://app.certifiedketodiet.com/direct_login/${accessToken}?${qs.stringify(
    queryParams
  )}`
}
